type TObjectProps = Record<string, unknown>;

export const deepEqual = (object1: TObjectProps, object2: TObjectProps): boolean => {
  if (!isObject(object1) || !isObject(object2)) {
    // eslint-disable-next-line eqeqeq
    return object1 == object2;
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1 as TObjectProps, val2 as Record<string, unknown>)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

function isObject(object: unknown) {
  return object != null && typeof object === 'object';
}
